/* eslint-disable no-underscore-dangle */
export default function hasLink(object, rel) {
	return !!(object._links && object._links[rel] && object._links[rel].href);
}
